import { FC } from 'react'
import style from './style.m.less'

export interface IImportButton {
    value: string
    icon?: React.ReactNode
    customStyle?: React.CSSProperties
    customIconStyle?: React.CSSProperties
    noMargin?: boolean
    isDisabled?: boolean
    onClick?: () => void
}

const ImportButton: FC<IImportButton> = ({
    // value,
    icon,
    customStyle,
    customIconStyle,
    onClick,
    // noMargin,
    isDisabled,
    ...rest
}) => {
    return (
        <button
            onClick={onClick}
            style={customStyle}
            className={isDisabled ? style.importDisabled : style.importButton}
            disabled={isDisabled}
            {...rest}
        >
            <div style={customIconStyle} className={style.icon}>
                {icon}
            </div>
        </button>
    )
}

export default ImportButton
